// extracted by mini-css-extract-plugin
export default {"chipList":"styles---chipList---obd7w"};